import React, { useState } from "react";
import { Button, RadioButtonGroup, RadioButton } from "carbon-components-react";
import { Download16 } from "@carbon/icons-react";
import { saveAs } from "file-saver";
import Card from "../../components/Card/Card";
import http from "../../http-common";
import { toast } from "react-toastify";

const ReportsPage = () => {
  const [windowCode, setWindowCode] = useState("1");
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      const response = await http.get(
        `/admin/reports/business-plans?windowCode=${windowCode}`,
        { responseType: "blob" }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `relatorio-planos-negocio-janela-${windowCode}.xlsx`);
    } catch (error) {
      toast.error("Erro ao gerar o relatório");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Card title="Relatórios">
      <p className="mb-2">
        Gere o relatório completo dos planos de negócio da janela seleccionada. Cada
        secção do plano (ficha técnica, perfil de negócio, análise de mercado,
        trabalhadores, plano de investimento, plano de vendas, plano previsional e
        análise socioambiental) sai numa folha de cálculo própria, incluindo as datas
        de registo da candidatura e do plano de negócio.
      </p>

      <RadioButtonGroup
        legendText="Janela"
        name="report-window"
        valueSelected={windowCode}
        onChange={(value) => setWindowCode(value)}
        style={{ marginTop: "1rem" }}
      >
        <RadioButton labelText="Janela 1" value="1" id="report-window-1" />
        <RadioButton labelText="Janela 2" value="2" id="report-window-2" />
      </RadioButtonGroup>

      <Button
        renderIcon={Download16}
        style={{ marginTop: "1.5rem" }}
        disabled={isDownloading}
        onClick={handleDownload}
      >
        Descarregar Relatório (Excel)
      </Button>
    </Card>
  );
};

export default ReportsPage;
